import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { RouteSeo } from "./components/Seo";
import Header from "./components/Header";
import Footer from "./components/Footer";
import MiraChat from "./components/MiraChat";
import HomePage from "./pages/HomePage";
import SubmitPage from "./pages/SubmitPage";
import StoryPage from "./pages/StoryPage";
import AdminPage from "./pages/AdminPage";
import LegalPage from "./pages/LegalPage";
import AboutPage from "./pages/AboutPage";
import InsightsPage from "./pages/InsightsPage";
import MirrorPage from "./pages/MirrorPage";
import IconsPage from "./pages/IconsPage";
import IconProfilePage from "./pages/IconProfilePage";
import ConversationsPage from "./pages/ConversationsPage";
import BecausePage from "./pages/BecausePage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SeoWrapper() {
  const { pathname } = useLocation();
  return <RouteSeo pathname={pathname} />;
}

function MiraWrapper() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;
  // Hide Mira orb on Mirror conversation pages (avoid overlap)
  if (pathname.match(/^\/mirror\/.+/)) return null;
  return <MiraChat />;
}

function FooterWrapper() {
  const { pathname } = useLocation();
  // Hide footer on Mirror conversation pages (with token) and admin
  if (pathname.startsWith("/admin")) return null;
  if (pathname.match(/^\/mirror\/.+/)) return null;
  return <Footer />;
}

function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <ScrollToTop />
      <SeoWrapper />
      <div className="flex flex-col min-h-screen">
        <Header />
        <main className="flex-1 flex flex-col">
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/submit" element={<SubmitPage />} />
            <Route path="/story/:id" element={<StoryPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/insights" element={<InsightsPage />} />
            <Route path="/mirror" element={<MirrorPage />} />
            <Route path="/mirror/:token" element={<MirrorPage />} />
            <Route path="/icons" element={<IconsPage />} />
            <Route path="/icons/:slug" element={<IconProfilePage />} />
            <Route path="/conversations" element={<ConversationsPage />} />
            <Route path="/because" element={<BecausePage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/privacy" element={<LegalPage page="privacy" />} />
            <Route path="/terms" element={<LegalPage page="terms" />} />
            <Route path="/guidelines" element={<LegalPage page="guidelines" />} />
          </Routes>
        </main>
        <FooterWrapper />
        <MiraWrapper />
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
